import { FETCH_APPSTORE_VERSION } from "./types";

export const fetchAppStoreVersion = (version: string): { type: string; payload: string } => {
    return {
        type: FETCH_APPSTORE_VERSION,
        payload: version,
    };
};
